<template>
  <v-flex
    v-if="getSocialSeparationQuestions"
    id="social_separation"
    class="question"
  >
    <h2 class="display-3 display-3_dark">
      {{ getSocialSeparationQuestions.label }}
    </h2>
    <ol class="questions-list">
      <SheetQuestion
        v-if="getSocialSeparationQuestions?.hasOwnProperty('someone_who_visits')"
        :label="getSocialSeparationQuestions?.someone_who_visits?.label"
        :required="getSocialSeparationQuestions?.someone_who_visits?.required"
      >
        <ConfirmButtons
          v-model="someoneWhoVisits"
          v-validate="{ required: getSocialSeparationQuestions?.someone_who_visits?.required }"
          class="mb-4"
          string
          :error-messages="errors.collect('someoneWhoVisits')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'someoneWhoVisits'"
          :disabled="readOnly"
        />
      </SheetQuestion>
      <SheetQuestion
        v-if="
          getSocialSeparationQuestions?.hasOwnProperty('how_often') && someoneWhoVisits === 'yes'
        "
        :label="getSocialSeparationQuestions?.how_often?.label"
        :required="getSocialSeparationQuestions?.how_often?.required"
        custom
        list-sign="lA"
      >
        <BaseRadio
          v-model="howOften"
          :required="getSocialSeparationQuestions?.how_often?.required"
          name="howOften"
          :values="howOftenResources"
          value-key="id"
          label-key="description"
          :disabled="readOnly"
        />
      </SheetQuestion>
    </ol>
  </v-flex>
</template>
<script>
import { mapGetters } from 'vuex';
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';

import SheetQuestion from '@/components/sheet/SheetQuestion.vue';
import { createHelpers } from 'vuex-map-fields';
import BaseRadio from '@/components/widgets/BaseRadio.vue';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';

const { mapFields } = createHelpers({
    getterType: 'sheet/getSocialSeparationField',
    mutationType: 'sheet/updateSocialSeparationField'
});

export default {
    name: 'SocialSeparation',
    mixins: [sheetResourcesGetter],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        ...mapGetters('sheet', ['getSocialSeparationQuestions']),
        ...mapFields(['howOften', 'someoneWhoVisits']),
        howOftenResources () {
            return this.getResources(this.getSocialSeparationQuestions?.how_often);
        }
    },
    watch: {
        someoneWhoVisits (value) {
            if (value === 'no') this.howOften = null;
        }
    },
    components: { SheetQuestion, ConfirmButtons, BaseRadio }
};
</script>
<style lang="scss"></style>
